import { render } from "./CourseRecommendation.vue?vue&type=template&id=6297936a&scoped=true"
import script from "./CourseRecommendation.vue?vue&type=script&lang=js"
export * from "./CourseRecommendation.vue?vue&type=script&lang=js"

import "./CourseRecommendation.vue?vue&type=style&index=0&id=6297936a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6297936a"]])

export default __exports__